// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"p_nIr","isSelected":"SdAAt"};